import { Button, Divider, Row, Table, Popconfirm, message } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IStaffDetail, IStaffSearch } from 'src/entity/DepartmentEntity';
import { IStateDepartment, IStoreState } from 'src/entity/StateEntity';
import { RouterConfig } from 'src/routers/urlConfig';
import DepartmentAdminService, { StaffRoleDict } from 'src/services/DepartmentAdminService';
import I18N from 'src/services/I18NService';

interface IProps extends RouteComponentProps {
  defaultDepartmentId: string | undefined,
  pagination: PaginationProps,
  loading: boolean,
  dataSource: IStaffDetail[],
  departmentState: IStateDepartment,
  onPaginationChange: (query:  Partial<IStaffSearch>) => void,
}

const mapStateToProps = ({
  departmentState,
}: IStoreState) => ({
  departmentState,
});


const DepartmentUserListComp: React.FC<IProps> = (props) => {
  const {
    defaultDepartmentId,
    history,
    pagination,
    loading,
    dataSource,
    departmentState,
    onPaginationChange,
  } = props;
  const { list: departmentList } = departmentState

  const tableColumns = [
    {
      title: I18N.get('departmentAdmin_staff_code'),
      key: 'code',
      dataIndex: 'code',
      width: '150px',
    },
    {
      title: I18N.get('common_name'),
      key: 'fullname',
      dataIndex: 'fullname',
    },
    {
      title: I18N.get('departmentAdmin_department'),
      key: 'department',
      dataIndex: 'department',
      render: (text: any, record: IStaffDetail, index: number): React.ReactNode => {
        const departmentName = DepartmentAdminService.getCascadeDepartmentName(record.department, departmentList);
        return (departmentName);
      }
    },
    {
      title: I18N.get('userAdmin_role'),
      key: 'role',
      dataIndex: 'role',
      width: '150px',
      render: (text: any, record: IStaffDetail, index: number): React.ReactNode => {
        let desc = '';
        const matchedItem = StaffRoleDict.find(item => item.value === record.role);
        if (matchedItem) {
          desc = I18N.get(matchedItem.key);
        }
        return (desc);
      }
    },
    {
      title: I18N.get('common_mobile'),
      key: 'mobile',
      dataIndex: 'mobile',
      width: '200px',
    },
    {
      title: I18N.get('common_status'),
      key: 'is_active',
      dataIndex: 'is_active',
      width: '100px',
      render: (text: any, record: IStaffDetail, index: number): React.ReactNode => {
        const desc = record.is_active ? I18N.get('common_status_start') : I18N.get('common_status_disable');
        return (<span style={{color: record.is_active ? '#52c41a' : '#ff4d4f'}}>{desc}</span>)
      }
    },
    {
      title: I18N.get('common_operation'),
      key: 'operation',
      dataIndex: 'operation',
      width: '200px',
      render: (text: any, record: IStaffDetail, index: number): React.ReactNode => {
        const title = record.is_active ? 'common_status_disable' : 'common_status_start';
        return (
          <div>
            <a onClick={() => handleEditClick(record)}>{I18N.get('common_edit')}</a>
            <Divider type="vertical" />
              <Popconfirm
                  title={`是否确认${I18N.get(title)}该用户?`}
                  onConfirm={() => handleStatusToggleClick(record)}
                  okText={I18N.get('common_ok')}
                  cancelText={I18N.get('common_cancel')}
                >
                  <a>{I18N.get(title)}</a>
              </Popconfirm>
            {/* {record.role === StaffRoles.Salesman && (
              <React.Fragment>
                <Divider type="vertical" />
                <a onClick={() => handleQRCodeClick(record)}>{I18N.get('departmentAdmin_qrcode_refresh')}</a>
              </React.Fragment>
            )} */}
          </div>
        );
      },
    },
  ];

  /**
   * 处理新增用户按钮点击事件
   */
  const handelAddUserClick = () => {
    const urlParam: {pathname: string, search?: string} = {
      pathname: `${RouterConfig.Urls.departmentAdmin}/detail`,
    };
    if (defaultDepartmentId) {
      urlParam.search = `department=${defaultDepartmentId}`;
    };
    history.push(urlParam);
  }

  const handleEditClick = (record: IStaffDetail) => {
    history.push({
      pathname: `${RouterConfig.Urls.departmentAdmin}/detail/${record.uuid}`,
    });
  }

  const handleStatusToggleClick = async(record: IStaffDetail) => {
    const toggleActive = !record.is_active;
    const isSuccessed = await DepartmentAdminService.toggleDepartmentStaffStatus(record.uuid, toggleActive);
    if (isSuccessed) {
      const messageText = toggleActive ? 'common_status_start' : 'common_status_disable';
      message.success(`${I18N.get(messageText)}${I18N.get('common_success')}`);
      const { current, pageSize } = pagination;
      const param: Partial<IStaffSearch> = {
        offset: ((current || 1) - 1) * (pageSize as number),
        limit: pageSize as number,
      }
      onPaginationChange(param);
    }
  }

  const handleTableChange = (paginationTable: PaginationProps) => {
    const {current, pageSize} = paginationTable;
    const param: Partial<IStaffSearch> = {
      offset: ((current || 1) - 1) * (pageSize as number),
      limit: pageSize as number,
    }
    onPaginationChange(param);
  }

  return (
    <section>
      <Row type="flex" align="middle" justify="space-between">
        <span style={{color: '#1fb8cd'}}>
          {`${I18N.get('common_total_prefix')} ${pagination.total} ${I18N.get('userAdmin_total_suffix')}`}
        </span>
        <Button
          type="primary"
          onClick={handelAddUserClick}
        >{I18N.get('nav_userAdmin_add')}</Button>
      </Row>
      <Table
        style={{marginTop: 16}}
        columns={tableColumns}
        loading={loading}
        rowKey='uuid'
        dataSource={dataSource}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </section>
  )
}
const DepartmentUserList = connect(mapStateToProps)(DepartmentUserListComp);
export default withRouter(DepartmentUserList);


// WEBPACK FOOTER //
// ./src/components/views/DepartmentAdmin/User/UserList.tsx